import React from 'react';

const Blog = () => {
    return (
        <div>
            <img className="w-100 mt-5 img-fluid" src="https://img.freepik.com/free-vector/neon-style-coming-soon-glowing-background-design_1017-25516.jpg?size=626&ext=jpg" alt="" />
        </div>
    );
};

export default Blog;